import * as Core from '@skylab-shared/core';
import { OrderKindModel } from '@skylab-shared/dataModel';
import { ContextKeys } from '../common/context-keys';


@Core.BO({ modelType: OrderKindModel })
export class OrderKindBO extends Core.BusinessObjectBase<OrderKindModel> {
	public constructor(
		weaver: Core.Weaver,
	) {
		super(weaver);
	}

	protected override async initializeAsync(): Promise<void> {
		await super.initializeAsync();

		await Promise.resolve([
			this.localContext.preload(ContextKeys.company),
		]);

		this.registerCoreFeatures();
	}

	public registerCoreFeatures(): void {
		this.readonly.setAsReadonly<OrderKindModel>([OrderKindModel, 'name']);
	}
}
